import { makeStyles } from '@mui/styles';

export const stickyWidthsServices = [
	250, // id
	250, // saleOrderId
	215, // serviceType
	150, // reference
	110, // saleOrderDealId
];

export const useStyles = makeStyles((theme) => {
	const stickyClasses = stickyWidthsServices.reduce(
		(acc, width, index) => {
			const left = stickyWidthsServices.slice(0, index).reduce((sum, w) => sum + w, 0);
			acc[`sticky${index + 1}`] = {
				position: 'sticky',
				left,
				background: theme.palette.background.paper,
				zIndex: 1020,
				minWidth: width,
				maxWidth: width,
				boxSizing: 'border-box',
				display: 'table-cell',
			};
			return acc;
		},
		{} as Record<string, Record<string, string | number>>,
	);

	return {
		...stickyClasses,
		tableWrapper: {
			position: 'relative',
		},
		tableRefreshing: {
			opacity: 0.72,
			pointerEvents: 'none',
			transition: 'opacity 0.15s ease',
		},
		tableLoadingOverlay: {
			position: 'absolute',
			top: theme.spacing(1),
			right: theme.spacing(1),
			zIndex: 2,
			display: 'flex',
			alignItems: 'center',
			gap: theme.spacing(1),
			padding: theme.spacing(0.5, 1),
			borderRadius: theme.spacing(1),
			backgroundColor: 'rgba(255,255,255,0.92)',
			boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
		},
		filtersCard: {
			padding: theme.spacing(2.5),
			borderRadius: theme.spacing(2),
			marginBottom: theme.spacing(2),
			background: 'white',
			boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
			border: '1px solid rgba(0,0,0,0.05)',
		},
		toolbarRow: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			flexWrap: 'wrap',
			gap: theme.spacing(1.5),
		},
		toolbarActions: {
			display: 'flex',
			alignItems: 'center',
			gap: theme.spacing(1),
		},
		resultsCount: {
			color: theme.palette.text.secondary,
			fontSize: '0.875rem',
			whiteSpace: 'nowrap',
		},
		tablePaper: {
			borderRadius: theme.spacing(2),
			overflow: 'hidden',
			border: '1px solid rgba(0,0,0,0.08)',
			boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
		},
		tableContainer: {
			overflowX: 'auto',
			'&::-webkit-scrollbar': { height: '10px' },
			'&::-webkit-scrollbar-thumb': {
				backgroundColor: theme.palette.primary.main,
				borderRadius: '5px',
			},
			'&::-webkit-scrollbar-track': {
				backgroundColor: 'rgba(0, 0, 0, 0.2)',
			},
		},
		tableHeader: {
			backgroundColor: theme.palette.primary.main,
			color: 'white',
			fontWeight: 600,
		},
		tableRow: {
			cursor: 'pointer',
			'&:hover': {
				backgroundColor: 'rgba(0,0,0,0.04)',
			},
		},
		cellNoWrap: {
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
		paginationBar: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			marginTop: theme.spacing(2),
			flexWrap: 'wrap',
			gap: theme.spacing(1),
		},
		checkboxCell: {
			width: 48,
		},
	};
});
